// src/utils/apolloEnrichment.js
import { saveToSession, getFromSession } from './sessionHelper';

export async function handleApolloEnrichment(aei) {
    if (!aei) return null;

    // Ako već postoji u sesiji, koristi ga
    const storedData = getFromSession('apolloEnrichment');

    if (storedData && storedData?.aei.toString() === aei) return storedData;

    const apiKey = process.env.REACT_APP_CRM_API_KEY;

    try {
        const res = await fetch(`${process.env.REACT_APP_CRM_SERVER_URL}/apollo_enrichment/${aei}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'x-api-key': apiKey },
        });
        const data = await res.json();

        console.log(data);

        if (data?.email && data?.name) {
            saveToSession('apolloEnrichment', data);
        }

        return data;
    } catch (error) {
        console.error('Apollo Enrichment API error:', error);
        return null;
    }
}
